<template>
  <div>
    <b-modal
      v-model="modal"
      id="modal-movetocreatebatch"
      title="รายการสินค้า"
      hide-footer
      size="md"
      no-close-on-backdrop
      no-close-on-esc
      header-class="bg-purple2"
    >
      <template #modal-header>
        <div class="w-100">
          <strong class="title-modal">สร้างแบทช์ใหม่</strong>
          <b-icon
            icon="x-circle-fill"
            class="float-right pointer"
            @click="closeModal"
          ></b-icon>
        </div>
      </template>
      <div class="filter-panel">
        <InputText
          v-model="form.NewBatchName"
          class="input-text"
          textFloat="ชื่อแบทช์"
          placeholder="กรุณากรอกชื่อแบทช์"
          type="text"
          isRequired
          :isValidate="$v.form.NewBatchName.$error"
          :v="$v.form.NewBatchName"
        />
        <div class="footer">
          <b-button class="btn-cancel-modal" @click="closeModal">
            ยกเลิก
          </b-button>
          <b-button class="btn-submit-modal" @click="moveToCreateBatch">
            สร้างแบทช์ใหม่
            <b-spinner
              v-if="loading"
              class="spinner"
              label="Loading..."
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    InputText,
  },
  props: {
    orderSelectArr: {
      type: Array,
      default: () => [],
    },
    orderList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        OrderId: [],
        NewBatchName: "",
        SellerShopId: null,
        ShppingId: null,
      },
      // state toggle
      modal: false,
      loading: false,
    };
  },
  validations() {
    return {
      form: {
        NewBatchName: { required },
      },
    };
  },
  watch: {
    modal(boolean) {
      if (boolean) {
        this.mapData();
      }
    },
  },
  methods: {
    mapData() {
      this.form.SellerShopId = this.orderSelectArr[0].sellerShopId;
      this.form.ShppingId = this.orderSelectArr[0].shippingTypeId;
      this.form.OrderId = this.orderList;
    },
    moveToCreateBatch() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.loading = true;

      this.axios
        .post(`${this.$baseUrl}/Batch/MoveToCreateBatch`, this.form)
        .then((result) => {
          if (result.result == 1) {
            this.form = {
              OrderId: [],
              NewBatchName: "",
              SellerShopId: null,
              ShppingId: null,
            };

            this.loading = false;

            this.$v.$reset();
            this.closeModal();
            this.$bvModal.hide("modal-moveorder");

            this.$emit("getBatchDetail");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeModal() {
      this.$bvModal.hide("modal-movetocreatebatch");
    },
  },
};
</script>

<style scoped>
.border-input {
  border: none;
}
.text-gray {
  color: #bcbcbc;
}
.btn-submit-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  color: #ffffff;
  background-color: #8f20c6;
  border-radius: 2px;
}
.btn-cancel-modal {
  width: 150px;
  color: #ffffff;
  background-color: #575757;
  border-radius: 2px;
}
.purple-btn {
  background-color: #ffffff;
  color: #8a44c3;
  border: 1px solid #8a44c3;
  width: 95%;
  min-height: 40px;
  min-width: 150px;
  transition: 0.3s;
}
.purple-btn:hover {
  background: #8a44c3;
  color: #ffffff;
  border: #8a44c3 solid 1px;
}
.cb-table {
  position: relative;
  margin-left: 15px;
  padding-top: 15px;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.spinner {
  margin-left: 5px;
  width: 15px;
  height: 15px;
}
</style>
